import { render, staticRenderFns } from "./VotingDetails.vue?vue&type=template&id=9de6c97a&scoped=true"
import script from "./VotingDetails.vue?vue&type=script&lang=js"
export * from "./VotingDetails.vue?vue&type=script&lang=js"
import style0 from "./VotingDetails.vue?vue&type=style&index=0&id=9de6c97a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de6c97a",
  null
  
)

export default component.exports